<template>
	<div class="expertConsult">
		<div class="expert-show">
			<img src="../../../assets/img/vip/expert.png"/>
			<div class="label" :class="policyExpertOnline? 'online': 'offline'">{{ statusObj[policyExpertOnline] }}</div>
		</div>
		<h3>咨询政策专家</h3>
		<p class="desc">
			针对政策内容，为VIP会员提供专家解读，以帮助VIP会员更快的理解政策内容及申报需要准备的事项
		</p>
		<div class="vip-btn-black vip-btn-black-adius-28" @click="getPhoneNumber">
			<span>立即咨询</span>
			<p class="text" v-if="Number(policyExpertLeftTimes)>-1">剩余{{ policyExpertLeftTimes || 0 }}次</p>
		</div>
		<a :href="'tel:' + phone" id="telphone" style="display: none">{{ phone }}</a>
	</div>
</template>

<script>
	// import { mapGetters } from 'vuex';
	import { expertTelephone } from '../../../api';

	export default {
		name: 'ExpertConsult',
		data() {
			return {
				statusObj: {
					0: '离线',
					1: '在线'
				},
				phone: '',
				disabled:false,
				policyExpertOnline: 1,
				policyExpertLeftTimes: -1
			}
		},
		// computed: {
		// 	...mapGetters(['policyExpertOnline','policyExpertLeftTimes'])
		// },
		methods: {
			call() {
				let comment = document.getElementById('telphone');
				if (document.all) {
					// For IE
					comment.click();
				} else if (document.createEvent) {
					//FOR DOM2
					let ev = document.createEvent('MouseEvents');
					ev.initEvent('click', false, true);
					comment.dispatchEvent(ev);
				}
			},
			// 获取专家电话
			async getPhoneNumber() {
				let params = {
					consultType:2,
				}
				await expertTelephone(params).then(res=>{
					if(res.ok===true){
						this.phone=res.data.expertMobile
						// 咨询电话埋点
						// eslint-disable-next-line
						sensors.track('advisoryPageClick', {
							advisory_object: '咨询政策专家'
						});
					}
				})
				this.call()
			},
		}
	};
</script>

<style lang="less" scoped>
	.expertConsult{
		padding: 0 16px;
		display: flex;
		flex-direction: column;
		align-items: center;
		.expert-show {
			position: relative;
			> img {
				width: 90px;
				height: auto;
				margin-top: 50px;
			}
			.label {
				position: absolute;
				bottom: -11px;
				left: 25px;
				width:40px;
				height:22px;
				line-height: 22px;
				margin-top: 29px;
				border-radius:3px;
				font-size:12px;
				text-align: center;
			}
			.label.online {
				color: #C89557;
				background:#F7EFE6;
			}
			.label.offline {
				color: #999999;
				background: #F5F5F5;
			}
		}
		h3 {
			margin-top: 29px;
		}
		.desc {
			font-size: 12px;
			color: @subBlack;
			margin-top: 37px;
		}
		.vip-btn-black {
			margin-top: 34px;
		}
	}

</style>
